import { Skeleton } from "antd";

import { RVGRID_COLUMN_SIZE_OPTIONS } from "../../consts";
import { defaultQueryParams, type useQueryParamsV6 } from "../../hooks/useQueryParams/useQueryParams";

import type { GridProps, QueryParams } from "../../RVGridTypes";

// Map of the widths defined in the column size styles (probably a better way to do this)
export const SkeletonSize: Record<string, number> = {
    [RVGRID_COLUMN_SIZE_OPTIONS.ID]: 40,
    [RVGRID_COLUMN_SIZE_OPTIONS.UUID]: 120,
    [RVGRID_COLUMN_SIZE_OPTIONS.XSMALL]: 120,
    [RVGRID_COLUMN_SIZE_OPTIONS.SMALL]: 180,
    [RVGRID_COLUMN_SIZE_OPTIONS.MEDIUM]: 240,
    [RVGRID_COLUMN_SIZE_OPTIONS.LARGE]: 300,
    [RVGRID_COLUMN_SIZE_OPTIONS.XLARGE]: 320,
    [RVGRID_COLUMN_SIZE_OPTIONS.XXLARGE]: 480,
};

type SkeletonRow = {
    rowKey: string;
};

export function createEmptyRowsList(
    queryParams: Partial<QueryParams> | ReturnType<typeof useQueryParamsV6>["queryParams"]
): Array<SkeletonRow> {
    // Empty data list for skeletons to render, generate enough blank rows to fill the table
    return Array(queryParams?.pageSize || defaultQueryParams.pageSize)
        .fill({})
        .map((_, index) => {
            return { rowKey: `skeleton-row-${index}` };
        });
}

export const SKELETON_HEIGHTS: Record<number, number> = {
    1: 32,
    2: 37.7,
    3: 56.5,
};

export const SKELETON_CELL_BASE_STYLES: React.CSSProperties = {
    display: "flex",
    flexFlow: "column nowrap",
    justifyContent: "center",
};

export function interceptColumnRenders(columns: GridProps["columns"], skeletonRowLines: number): GridProps["columns"] {
    // Overwrite the render method and strip sorter/filters since skeleton rows have no real data
    return columns?.map((c, idx) => {
        return {
            ...c,
            sorter: undefined,
            onFilter: undefined,
            filters: undefined,
            /* eslint-disable react/display-name */
            render: () => (
                // Set width of skeleton to column width minus a bit of padding
                <Skeleton
                    key={idx}
                    active
                    paragraph={false}
                    style={{
                        height: SKELETON_HEIGHTS[skeletonRowLines],
                        ...SKELETON_CELL_BASE_STYLES,
                    }}
                    title={{ width: SkeletonSize[c.size] - 20 }}
                ></Skeleton>
            ),
        };
    });
}
